var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { fill: "#303030", fillRule: "evenodd", d: "M12 8v6h2V7.46L8 2.317 2 7.46V14h2V8h8zm-7 4h6v-1H5v1zm0 1v1h6v-1H5zm0-3h6V9H5v1zM1.35 6.7L8 1l6.65 5.7a1 1 0 0 1 .35.76V14a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V7.46a1 1 0 0 1 .35-.76z" })
  );
});